import ReportUserRewardsList from './report-user-rewards.list';

export default {
  list: ReportUserRewardsList,
};
